import { withModifiers as _withModifiers, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-23503118")

_pushScopeId("data-v-23503118")
const _hoisted_1 = { class: "position-relative" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "select_overlay",
      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args)), ["stop","prevent"]))
    }),
    _withDirectives(_createVNode("select", {
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.localValue = $event)),
      tabindex: _ctx.tabIndex,
      readonly: _ctx.readonly
    }, [
      (_ctx.placeholderKey && _ctx.placeholderValue)
        ? (_openBlock(), _createBlock("option", {
            key: 0,
            hidden: "",
            disabled: "",
            value: _ctx.getDefaultValue
          }, _toDisplayString(_ctx.$localizationService.getLocalizedValue(_ctx.placeholderKey, _ctx.placeholderValue)), 9, ["value"]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.localList, (item, i) => {
        return (_openBlock(), _createBlock("option", {
          key: i,
          value: item.identifier
        }, _toDisplayString(_ctx.showIdentifier ? item.identifier : item.text), 9, ["value"]))
      }), 128))
    ], 8, ["tabindex", "readonly"]), [
      [_vModelSelect, _ctx.localValue]
    ])
  ]))
})